import React from 'react';
import { Label } from '@fluentui/react';
import { useEffect, useState } from 'react';
import { AvailableMedicalService } from '../../../../models/Entities/MedicalServices/AvailableMedicalService';

// own functions
import * as ownFunctions from './MedicalServiceSelectorFunctions';
import { connect } from 'react-redux';
import { Field, Spinner, Tag, TagPicker, TagPickerControl, TagPickerGroup, TagPickerInput, TagPickerList, TagPickerOption, TagPickerProps } from '@fluentui/react-components';

const MedicalServiceSelectorComponent = (
  props: ownFunctions.Props
) => {


  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);

  useEffect(() => {
    if (!props.MedicalServices || props.MedicalServices.length === 0) {
      props.GetAllMedicalServices(1, 5000, undefined);
    }
  }, [props.GetAllMedicalServices, props.MedicalServices, props.MedicalServices?.length]);

  useEffect(() => {
    if (props.MedicalServices?.length > 0 && props.MedicalServicesSelectedIds && props.MedicalServicesSelectedIds.length > 0) {
      const currentSelected = props.MedicalServices
        .filter((ms: AvailableMedicalService) => props.MedicalServicesSelectedIds?.includes(ms.id))
        .map((ms: AvailableMedicalService) => ms.serviceNameReference);
      setSelectedOptions(currentSelected);
      return;
    }

    if (!props.isLoading && (!props.MedicalServicesSelectedIds || props.MedicalServicesSelectedIds.length === 0)) {
      setSelectedOptions([]);
    }

  }, [props.MedicalServices, props.MedicalServicesSelectedIds, props.isLoading]);

  const handleTagDismiss = (option: string) => {
    if (props.MultiselectEnable) {
      const remaining = selectedOptions.filter((o) => o !== option);
      setSelectedOptions(remaining);
      const remainingServices = props.MedicalServices?.filter(
        (s: AvailableMedicalService) => remaining.includes(s.serviceNameReference)
      );
      props.onSelectedServices?.(remainingServices?.length ? remainingServices : undefined);
    } else {
      setSelectedOptions([]);
      props.onSelectedServices && props.onSelectedServices(undefined);
    }
  };

  const onOptionSelect: TagPickerProps["onOptionSelect"] = (e, data) => {
    if (data.selectedOptions.length === 0) {
      // Fluent UI TagPicker fires this event when the chevron/expand button is clicked
      // in single-select mode (to "release" the current selection back into the list).
      // Deselection in single-select mode is handled exclusively by handleTagDismiss.
      if (!props.MultiselectEnable) {
        return;
      }
      setSelectedOptions([]);
      props.onSelectedServices && props.onSelectedServices(undefined);
      return;
    }

    const selectedValue =
      (typeof data.value === 'string' && data.value.length > 0
        ? data.value
        : data.selectedOptions.at(-1)) || '';

    if (!selectedValue) return;

    let InternalSelected: AvailableMedicalService[] = [];

    if (props.MultiselectEnable) {
      InternalSelected = props.MedicalServices?.filter((service: AvailableMedicalService) => data.selectedOptions.includes(service.serviceNameReference)) ?? [];
      setSelectedOptions(InternalSelected.map((service: AvailableMedicalService) => service.serviceNameReference));
    } else {
      const InternalItemSelected = props.MedicalServices?.find((service: AvailableMedicalService) => service.serviceNameReference === selectedValue);
      if (!InternalItemSelected) {
        return;
      }
      InternalSelected = [InternalItemSelected];
      setSelectedOptions([selectedValue]);
    }

    props.onSelectedServices && props.onSelectedServices(InternalSelected);
  };

  const tagPickerOptions = props.MedicalServices?.map((service: AvailableMedicalService) => service.serviceNameReference)?.filter(
    (service: string) => !selectedOptions?.includes(service)
  );

  let optionsContent = (
    <div role="note" aria-live="polite" style={{ padding: '8px 12px' }}>
      No hay conceptos disponibles
    </div>
  );

  if (props.isLoading) {
    optionsContent = (
      <div role="status" aria-live="polite">
        <Spinner size="tiny" />
      </div>
    );
  } else if (tagPickerOptions?.length > 0) {
    optionsContent = (
      <>
        {tagPickerOptions.map((option) => (
          <TagPickerOption
            value={option}
            key={option}
          >
            {option}
          </TagPickerOption>
        ))}
      </>
    );
  }

  return (
    <>
      <Field label="Seleccione una práctica médica">
        {props.isLoading && selectedOptions.length === 0 && (
          <div role="status" aria-live="polite" style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
            <Spinner size="tiny" />
            <span>Cargando prácticas médicas...</span>
          </div>
        )}
        <TagPicker
          onOptionSelect={onOptionSelect}
          selectedOptions={selectedOptions}
        >
          <TagPickerControl>
            <TagPickerGroup aria-label="practicas seleccionadas">
              {selectedOptions?.map((option) => (
                <Tag
                  key={option}
                  shape="rounded"
                  dismissIcon={{
                    'aria-label': 'Quitar',
                    onClick: (e: React.MouseEvent) => {
                      e.stopPropagation();
                      handleTagDismiss(option);
                    }
                  }}
                >
                  {option}
                </Tag>
              ))}
            </TagPickerGroup>
            <TagPickerInput aria-label="Seleccione una practica médica" />
          </TagPickerControl>
          <TagPickerList>
            {optionsContent}
          </TagPickerList>
        </TagPicker>
      </Field>

      {props.noteText && <small>{props.noteText}</small>}
    </>
  );
};

export default connect(
  ownFunctions.mapStateToProps,
  ownFunctions.mapDispatchToProps
)(MedicalServiceSelectorComponent as any);
